import { render, staticRenderFns } from "./PersonEnterContent.vue?vue&type=template&id=4ca3a04f&scoped=true"
import script from "./PersonEnterContent.vue?vue&type=script&lang=js"
export * from "./PersonEnterContent.vue?vue&type=script&lang=js"
import style0 from "./PersonEnterContent.vue?vue&type=style&index=0&id=4ca3a04f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca3a04f",
  null
  
)

export default component.exports